import { ApiClient, ApiProvider } from 'jsonapi-react';
import React, { createContext, type ReactNode, useMemo } from 'react';
import { getSchema } from '../index';

export interface JsonApiProviderProps {
  children?: ReactNode;
  baseUrl?: string;
  accessToken?: string;
}

export const JsonApiAuthContext = createContext<{ authHeader?: string }>({});

export const JsonApiProvider = ({
  children,
  baseUrl,
  accessToken,
}: JsonApiProviderProps): ReactNode => {
  const authHeader = useMemo(
    () => (accessToken ? `Bearer ${accessToken}` : undefined),
    [accessToken]
  );

  const client = useMemo(() => {
    const defaultApiClient = new ApiClient({
      url: baseUrl ?? '',
      schema: getSchema(),
      headers: {
        Authorization: authHeader,
      },
      cacheTime: 0,
    });
    return defaultApiClient;
  }, [authHeader]);

  return (
    <ApiProvider client={client}>
      <JsonApiAuthContext.Provider value={{ authHeader }}>{children}</JsonApiAuthContext.Provider>
    </ApiProvider>
  );
};

JsonApiProvider.defaultProps = {
  children: null,
  baseUrl: null,
  accessToken: null,
};
